export default __webpack_public_path__ + "static/image05-3ef23d066a518138ce9da7c687cc84aa.webp";